import { BillingDetailsForm } from '@/components/billing/BillingDetailsForm'
import { useJobillaOrgId } from '@/hooks'
import { useAuth } from '@/lib'
import { SelectField } from '@/ui'
import type { BillingProfileData } from '@jobilla/nexus-sdk'
import { useTranslation } from 'react-i18next'

interface DetailsStepProps {
	profiles: BillingProfileData[]
	profile: BillingProfileData | null
	onProfileChange: (profileId: string) => void
	onSaved: (profile: BillingProfileData) => void
}

export function DetailsStep({ profiles, profile, onProfileChange, onSaved }: DetailsStepProps) {
	const { t } = useTranslation('common')
	const { can } = useAuth()
	const organisationId = useJobillaOrgId()

	return (
		<div className="mx-auto max-w-lg space-y-6">
			<div>
				<h1 className="text-2xl font-bold text-grey-900">{t('subscribe.details.title')}</h1>
				<p className="mt-1 text-sm text-grey-600">{t('subscribe.details.description')}</p>
			</div>

			{profile && profiles.length > 1
				? (
					<SelectField
						label={t('subscribe.details.profile')}
						options={profiles.map((option) => option.id)}
						value={profile.id}
						onChange={onProfileChange}
						renderOption={(profileId) => {
							const option = profiles.find((candidate) => candidate.id === profileId)
							return option?.name ?? option?.stripeCustomerId ?? profileId
						}}
					/>
				)
				: null}

			{can('profile:edit')
				? (
					<BillingDetailsForm
						key={profile?.id ?? 'new'}
						organisationId={organisationId}
						profile={profile}
						submitLabel={t('subscribe.continue')}
						onSaved={onSaved}
					/>
				)
				: <p className="text-sm text-grey-600">{t('subscribe.details.noPermission')}</p>}
		</div>
	)
}
